/**
 * The full list of Material Icons can be found here https://fonts.google.com/icons
 */

import React, {HTMLAttributes} from 'react';
import cx from 'classnames';
import {isFunction} from 'lodash';
import './icon.scss';

export type IconProps = {
  testId?: string;
  name: string;
  outlined?: boolean;
  onClick?: (() => unknown) | undefined;
  label?: string;
  disabled?: boolean;
} & HTMLAttributes<HTMLSpanElement>;

export function Icon({
  name,
  className,
  onClick,
  testId = '',
  outlined = false,
  label,
  disabled = false,
}: IconProps) {
  return isFunction(onClick)
    ? (
      <button
        data-testid={testId}
        className={cx('icon-button', 'material-icons', 'qep-icon', className, {
          'material-icons-outlined': outlined,
        }, disabled ? 'disabled' : '')}
        onClick={() => onClick()}
        aria-label={label}
        disabled={disabled}
      >
        {name}
      </button>
    )
    : (
      <span
        data-testid={testId}
        className={cx('material-icons', 'qep-icon', className, {
          'material-icons-outlined': outlined,
        }, disabled ? 'disabled' : '')}
      >
        {name}
      </span>
    );
}
